<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/apppointsshopmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/apppointsshopmanage/add"
    >
      <el-form-item label="机构名称" prop="name">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.name"
          placeholder="请输入机构名称"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="支付方式">-->
      <!--<el-select v-model="formModel.payTypeScope">-->
      <!--<el-option-->
      <!--v-for="item in payTypeScope"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey"-->
      <!--&gt;-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        label="机构名称"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="connPerson"
        label="姓名"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="connTel"
        label="电话"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
       <el-table-column
        prop="withdrawFee"
        label="提现手续(百分比)"
        min-width="180"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="withdrawRate"
        label="提现手续(元)"
        min-width="120"
        show-overflow-tooltip
      >
       <template slot-scope="scope">
          <p>{{ scope.row.withdrawRate / 100 }}</p>
        </template>
      </el-table-column>
   <el-table-column
        prop="fee1"
        label="大额封顶费率"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="fee2"
        label="小额封顶费率"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="fudongbili"
        label="浮动比例"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        v-if="
          hasPerm('/apppointsshopmanage/update') ||
          hasPerm('/apppointsshopmanage/del')
        "
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
              <el-button
            type="text"
            @click="handleStatus(scope.row.id, scope.row.status)"
            class="button-color"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
          <!-- <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button> -->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="300px"
      dialogWidth="589px"
    >
      <el-form-item label="机构名称" prop="tatName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.tatName"
          placeholder="请输入机构名称"
          style="width: 180px"
        ></el-input>
      </el-form-item>

      <el-form-item label="姓名" prop="connPerson">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.connPerson"
          placeholder="请输入姓名"
          style="width: 180px"
        ></el-input>
      </el-form-item>

      <el-form-item label="电话" prop="connTel">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.connTel"
          placeholder="请输入电话"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="借/贷记卡/云闪付大额封顶" prop="fee1">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.fee1"
          placeholder="请输入大额封顶费率"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="微信/支付宝/云闪付小额封顶" prop="fee2">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.fee2"
          placeholder="请输入小额封顶费率"
          style="width: 180px"
        ></el-input>
      </el-form-item>
         <el-form-item label="浮动比例" prop="fudongbili">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.fudongbili"
          placeholder="请输入浮动比例"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="姓名" prop="userName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.userName"
          placeholder="请输入姓名"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="身份证号" prop="idCard">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.idCard"
          placeholder="请输入身份证号"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="卡号" prop="cardNo">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.cardNo"
          placeholder="请输入卡号"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="手机号" prop="phone">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.phone"
          placeholder="请输入手机号"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <!-- 新增 -->
          <el-form-item label="提现手续(百分比)" prop="withdrawFee" style="width: 100%">
            <el-input-number
              :controls="false"
              v-model="dialogModel.withdrawFee"
              controls-position="right"
              :precision="2"
              :step="0.1"
              @change="handleChange"
              :min="0"
              style="width: 180px"
            ></el-input-number>
            <span>%</span>
          </el-form-item>
             <el-form-item prop="withdrawRate" label="提现手续(元)">
            
                <el-input-number
                  :controls="false"
                  placeholder="请输入"
                  v-model="dialogModel.withdrawRate"
                  controls-position="right"
                  :precision="2"
                  :step="0.1"
                  @change="handleChange"
                  :min="0"
                  style="width: 180px"
                ></el-input-number>
                <!-- <p class="unit">元/笔(机构)</p> -->
              
          </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import Institutionlist from "service/Ainstitution";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        name: "",
        payTypeScope: "",
      },
      tableData: [],
      submitService: Institutionlist.signList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        tatName: "",
        connPerson: "",
        connTel: "",
        fee1: '',
        fee2: "",
        fudongbili: '',
        userName: '',
        idCard: "",
        cardNo: "",
        phone: "",
         withdrawFee:"0",
        withdrawRate:"0",
       

        // goodName: "",
      },
      payTypeScope: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      dialogRules: {
          withdrawRate: [
          {
            required: true,
            message: "请输入",
          },
        ],
          withdrawFee: [
          {
            required: true,
            message: "请输入",
          },
        ],
          userName: [
           {
            required: true,
            message: "请输入",
          }
        ],
          idCard: [
          {
            required: true,
            message: "请输入",
          },
        ],
          cardNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入",
          },
        ],
        fudongbili: [
           {
            required: true,
            message: "请输入",
          }
        ],
          fee1: [
          {
            required: true,
            message: "请输入",
          },
        ],
          fee2: [
          {
            required: true,
            message: "请输入",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
          },
        ],
        typeTwo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        artNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        goodName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        residueNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payTypeScope: [
          {
            required: true,
            message: "请选择",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入",
          },
        ],
        signPrice: [
          {
            required: true,
            message: "请输入",
          },
        ],
        couponGroupId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
      },
      typeList: [
        {
          dictKey: "1",
          dictValue: "每月推荐",
        },
        {
          dictKey: "2",
          dictValue: "积分精品",
        },
        {
          dictKey: "3",
          dictValue: "优惠券",
        },
      ],
      typeTwoList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("merchantPayType", (res) => {
      this.payTypeScope = [...this.payTypeScope, ...res];
    });
    this.getTypeNames("积分精品商城", (res) => {
      this.typeTwoList = res;
    });
  },
  computed: {
    submitData() {
      this.params = {
        tatName: this.formModel.name,
        payTypeScope: this.formModel.payTypeScope,
        current: this.isPage ? this.page.currentPage : 1,
         size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
          withdrawFee: this.dialogModel.withdrawFee,
          withdrawRate: this.dialogModel.withdrawRate * 100,
        tatName: this.dialogModel.tatName,
        connPerson: this.dialogModel.connPerson,
        connTel: this.dialogModel.connTel,
        fee1: this.dialogModel.fee1,
        fee2: this.dialogModel.fee2,
        fudongbili: this.dialogModel.fudongbili,
        userName: this.dialogModel.userName,
        idCard: this.dialogModel.idCard,
        cardNo: this.dialogModel.cardNo,
        phone: this.dialogModel.phone,
        userId: this.userId,
        // goodName: this.dialogModel.goodName,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      console.log(this.itemId)
      return this.itemId
        ? Institutionlist.editInstitution
        : Institutionlist.addInstitution;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId","tatSimpleId"]),
  },
  watch: {},
  methods: {
    
    load() {
      this.formModel = {
        payTypeScope: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getCouponList();
   
    },
    // 启用禁用
        handleStatus(id, status) {
      this.showConfirm(`确定${status == 1 ? "禁用" : "启用"}该素材？`)
        .then(() => {
          this.doStatus(id, status);
        })
        .catch(() => {});
    },
     doStatus(id, status) {
      this.doLoad(
        Institutionlist.editStatus,
        {
          userId: this.userId,
          id: id,
          status: status == 1 ? 0 : 1,
          tatId: this.tatId
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents.optMsg);
            this.getList()
          });
        },
        "信息获取失败"
      );
    },
    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },
  
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.apppointsshopmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
 
    openAddDialog(item, flag) {
      console.log(item, "item");
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.withdrawRate =   (this.dialogModel.withdrawRate * 100) / 10000;
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);
        if (!this.dialogModel.otherImgsUrl) {
          this.dialogModel.otherImgsUrl = [];
        } else {
          this.dialogModel.otherImgsUrl =
            this.dialogModel.otherImgsUrl.split(",");
        }
      }
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
         withdrawFee: "0",
           withdrawRate: "0",
        tatName: "",
        connPerson: "",
        connTel: "",
        fee1: '',
        fee2: '',
        fudongbili: '',
        userName: '',
       idCard: '',
        cardNo: "",
        phone: ''
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/InstitutionList/Institutionlist.vue